import { AppRoute } from "./routes";

export type UiVersion = "v1" | "v2";

export function getVersionLink(route: AppRoute, version?: UiVersion): string {
    return version ? `/${version}${route}` : route;
}
